module.exports = __webpack_public_path__ + "static/media/play-area-bg.35cc96e0.png";